// extracted by mini-css-extract-plugin
module.exports = {"meals":"AvailableMeals_meals__2ZLCP","meals-appear":"AvailableMeals_meals-appear__ONwLi","MealsLoading":"AvailableMeals_MealsLoading__UmYIn"};